import React, { createRef } from 'react'

class OutsideClickHandler extends React.Component {
  wrapperRef = createRef()

  static defaultProps = {
    onOutsideClick: () => {},
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    const { onOutsideClick } = this.props
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      onOutsideClick()
    }
  }

  render() {
    const { children } = this.props

    return <div ref={this.wrapperRef}>{children}</div>
  }
}

export default OutsideClickHandler
